/**
 * Success-state flag for hiding the page banner while the MSME registration
 * success view is mounted. Consumers must also require an MSME registration
 * pathname so a stale flag cannot blank banners on unrelated routes.
 */
type Listener = () => void;

let suppressBannerForMsmeRegistrationSuccess = false;
const listeners = new Set<Listener>();

export function setMsmeRegistrationSuccessBannerHidden(hidden: boolean): void {
  if (suppressBannerForMsmeRegistrationSuccess === hidden) {
    return;
  }
  suppressBannerForMsmeRegistrationSuccess = hidden;
  listeners.forEach((listener) => listener());
}

export function getMsmeRegistrationSuccessBannerHidden(): boolean {
  return suppressBannerForMsmeRegistrationSuccess;
}

export function subscribeMsmeRegistrationSuccessBannerHidden(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** True only on MSME registration routes while the success suppress flag is set. */
export function shouldHidePageBannerForMsmeRegistrationSuccess(pathname: string): boolean {
  if (!getMsmeRegistrationSuccessBannerHidden()) {
    return false;
  }
  const path = pathname || '/';
  return path === '/msme-registration' || path.startsWith('/msme-registration/');
}
